<AuthCard>
    <div v-if="twoFactorEmail">
        <h2>Login</h2>
        <p>
            Use your authenticator app to generate a security code for the
            login.
        </p>
        <TwoFactorForm @submit="submitTwoFactor" :loading="loading" />
    </div>
    <CredentialsForm v-else @submit="submitLogin" :loading="loading" />
</AuthCard>